module.exports = __webpack_public_path__ + "img/0c43f7b.svg";